module.exports = "pegasus/assets/blocks/image-1-theme6.png";